import { http } from '../../config/axios'

export interface DescontoFaturaRequest {
  idFatura: string
  valorDesconto: number
  descricao: string
}

export default function postFaturaDescontoService(
  request: DescontoFaturaRequest
): Promise<string> {
  return http
    .post('/api/fatura/desconto', request)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ao aplicar desconto na fatura', error)
      throw Error(error.response?.data)
    })
}
